// extracted by mini-css-extract-plugin
export default {"page":"UnauthorizedCatalog_page__nnov+","header":"UnauthorizedCatalog_header__AJthm"};